import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that checks if the current URL path corresponds to a fund page
 * Fund URLs follow the pattern: /firms/:firmSlugParam/funds/:fundSlugParam/:tableSlugParam
 * 
 * @returns {boolean} True if the current path is a fund path, false otherwise
 */
export const useIsFundPath = (): boolean => {
  const location = useLocation();

  const isFundPath = useMemo(() => location.pathname.includes('/funds/'), [location.pathname]);

  return isFundPath;
};
